import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const customEmailNotificationStyle = StyleSheet.create({
    searchContainerStyle: {
        backgroundColor: appColors.light, height: 50
    },
    openPurchaseHeader: {
        flexDirection: "row", justifyContent: "space-between", height: 25, margin: 20
    },
    container: { flex: 1, },
    headerView: {
        flexDirection: 'row',
        marginLeft: 5, marginVertical: 5
    },
    buttonContainerStyle: {
        marginHorizontal: 5,
        marginVertical: 13,
    },
    buttonTitleStyle: {
        fontSize: fontSize.mediumFontSize,
    },
    buttonStyle: { borderRadius: 7, borderColor: appColors.primary, padding: 10 },
    listFooterComponentStyle: { height: 30 },
    listFooterStyle: { paddingBottom: 20 },
    createModalView: { backgroundColor: appColors.light, borderRadius: 8, flex: 1 },
    headerText: { alignItems: 'flex-start', fontSize: fontSize.largerFontSize, fontFamily: appFonts.bold, color: appColors.lightDark },
    createModalHeaderView: { backgroundColor: appColors.lightBackgroundColor },
    createContainerView: { marginVertical: 10, marginLeft: 20, flex: 1 },
    createDropdownView: { marginTop: 10, marginBottom: 10, marginRight: 20, zIndex: 1 },
    errorStyle: {
        fontSize: fontSize?.errorFontSize, fontFamily: appFonts?.medium, color: appColors?.red,
    },
    createSubjectInputContainerStyle: { right: 10, top: 5 },
    createRichToolbarContainer: { marginBottom: 10, marginRight: 20, flex: 1 },
    createRichEditorContainerStyle: {
        height: 300,
        flex: 1,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderBottomWidth: 1,
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderTopWidth: 0,
        borderColor: appColors.lightGrey,
    },
    createFooterContainer: { flexDirection: 'row', marginBottom: 15, marginHorizontal: 20, alignSelf: "flex-end" },
    outlineButtonStyle: { height: 40, borderRadius: 7, backgroundColor: appColors.light, borderWidth: 1, borderColor: appColors.primary, },
    solidButtonStyle: { height: 40, borderRadius: 7, backgroundColor: appColors.primary, marginLeft: 10 },
    viewModalContainer: { flex: 1, backgroundColor: appColors.transparentBackground, justifyContent: 'center', alignItems: 'center' },
    viewModalView: { backgroundColor: appColors.light, borderRadius: 8, },
    viewModalHeaderContainer: { backgroundColor: appColors.lightBackgroundColor, borderTopLeftRadius: 16, borderTopRightRadius: 16 },
    viewContainerView: { padding: 20, },
    viewCustomerEmailsContainer: { marginBottom: 10, rowGap: 5 },
    flexDirection: { flexDirection: 'row', alignSelf: "flex-start" },
    viewCustomerEmailView: { backgroundColor: appColors.lightBackgroundColor, marginHorizontal: 5, borderRadius: 16, paddingHorizontal: 10, paddingTop: 7 },
    viewHeadertext: { marginTop: 5, marginBottom: 10, rowGap: 5 },
    floatingButton: { position: "absolute", backgroundColor: appColors.primary, width: 60, height: 60, borderRadius: 32, top: '85%', left: '80%', justifyContent: 'center' }
})